import { ColumnTypes, ExtendedColumnProps } from '../../../../utils/dataTable/column';
import { IAllocationDisplayItem } from '../interfaces';

export const ACTION_COLUMN_KEY = 'manage_minutes_actions_key';
export const MINUTES_COLUMN_KEY = 'display_minutes_key';

export const COLUMN_WIDTHS = {
  inPercentage: {
    term: 43,
    minutes: 25,
    updated: 25,
    actions: 7
  }
} as const;

export const ManageMinutesTableColumns: ExtendedColumnProps<IAllocationDisplayItem>[] = [
  {
    title: 'Term',
    dataIndex: ['display', 'termRange'],
    key: 'term',
    dataType: ColumnTypes.Date,
    autoWidth: false,
    width: `${COLUMN_WIDTHS.inPercentage.term}%`
  },
  {
    title: 'Minutes',
    dataIndex: ['display', 'minutes'],
    key: MINUTES_COLUMN_KEY,
    dataType: ColumnTypes.Numeric,
    autoWidth: false,
    width: `${COLUMN_WIDTHS.inPercentage.minutes}%`
  },
  {
    title: 'Updated',
    dataIndex: ['display', 'updatedAt'],
    key: 'updated_at',
    dataType: ColumnTypes.Date,
    autoWidth: false,
    width: `${COLUMN_WIDTHS.inPercentage.updated}%`
  },
  {
    title: '',
    key: ACTION_COLUMN_KEY,
    dataType: ColumnTypes.CustomComponent,
    autoWidth: false,
    width: `${COLUMN_WIDTHS.inPercentage.actions}%`
  }
];
